export function navigateLandingSSR() {
  window.location.href = window.location.origin
}

export function navigateToSSRPage(path = '/') {
  window.location.href = path
}

export function replaceToLandingSSR() {
  window.location.replace(window.location.origin)
}
